// extracted by css-extract-rspack-plugin
export default {"cls1":"FeedbackPopover-cls1_laz","cls2":"FeedbackPopover-cls2_uTn FeedbackPopover-cls1_laz"};